<template>
<div>
    <v-container>
        <div :class="{'mx-9':$vuetify.breakpoint.lgAndUp, 'mx-0': $vuetify.breakpoint.mdAndDown}">
        <v-toolbar flat color="#F0FFEA" height="50" >
            <v-toolbar-title style="color:#62AE32" class="headline">{{community}}: {{name}}</v-toolbar-title>
        </v-toolbar>    

         <v-snackbar v-model="snackbar" :timeout="4000" top color="success">
            <span>Role successfully uppdated..</span> 
            <v-btn text color="white" @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-snackbar v-model="snackbar2" :timeout="4000" top color="red">
            <span>Role update not successful..</span> 
            <v-btn text color="white" @click="snackbar2 = false">Close</v-btn>
        </v-snackbar>
        <v-toolbar flat color="#F0FFEA">
            <v-spacer></v-spacer>
            <v-dialog persistent v-model="dialog" max-width="300px">
                <template v-slot:activator="{ on }">
                    <v-btn large color="#08911B" class="pa-3 mt-3" width="200" dark style="border-radius:20px" v-on="on">
                        <v-icon>mdi-plus</v-icon>
                        <span>Update Role</span>
                    </v-btn> 
                </template>
                <v-card>
                    <v-card-title>
                    <span class=" black--text">Update Role</span>
                    </v-card-title>

                    <v-card-text>
                    <v-container>
                        <v-checkbox
                            v-model="checkAdmin"
                            label="Admin"
                            color="#62AE32"
                            value="ADMIN"
                        ></v-checkbox>                 
                    </v-container>
                    </v-card-text>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#62AE32" text @click="save">CANCEL</v-btn>
                    <v-btn color="#62AE32" :loading="loading" text @click="update">UPDATE</v-btn>
                    
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-toolbar>
          
        <div class="mt-6">
            <v-card class="ml-4" color="#F0FFEA" max-width="400" flat> 
                <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                    <span style="font-size:13px; color:#615D5D">Name</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            solo
                            flat
                            dense
                            v-model="name"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Username</span>
                        
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="clientId"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Community</span>
                        
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="community"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6">
                        <span style="font-size:13px; color:#615D5D">Active Policy</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="activePolicyNumber"
                            style="font-size:14px"
                            class="black-text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Phone Number</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="contact"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4">
                    <v-col class="mt-2" cols="12" md="4" sm="6">
                        <span style="font-size:13px; color:#615D5D">Role</span>
                        
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="member.priviledges"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row >
                <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Bank Name</span>                  
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="bankName"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Account Name</span>                  
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="accountName"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                 <v-row no-gutters class="mb-n4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Account Number</span>                  
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="accountNumber"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-card>
        </div>
        <v-tabs color="#B45C5C" background-color="#F0FFEA" class="mt-4">
            <v-tab class="black--text">Policy Details</v-tab>
            <v-tab class="black--text">Claims</v-tab>

            <v-tab-item>
               <v-card>
                   <v-card-title>
                       <v-spacer></v-spacer>
                        <v-select outlined :items="claimStatus" label="select policy type..."  color="#62AE32" v-model="policyStatus" dense class="mt-6" style="width:10%"  @change="onChange($event)" flat></v-select>
                    </v-card-title>
                    <v-divider></v-divider>
                    <template>
                    <v-data-table
                    :headers="headers"
                    :items="ViewMember"
                    :class="elevation-1"  
                    class="px-5"
                    :items-per-page="5"
                    :search="search"  
                    no-data-text="This Member Has Not Subscribed To Any Policy"
                    >
                    <!-- <template  v-slot:top>
                        <v-toolbar flat color="white">
                            <v-spacer></v-spacer>
                            <v-select outlined :items="claimStatus" label="select policy type..."  color="#62AE32" v-model="policyStatus" dense class="mt-6" style="width:10%"  @change="onChange($event)" flat></v-select>
                        </v-toolbar>
                        <v-divider class=""></v-divider>
                    </template> -->
                    <template v-slot:item.action="{ item }">
                        <v-icon
                            style="color:#B45C5C; cursor: pointer;"
                            @click="getPolicy(item.subscription_id)"
                         >
                            mdi-chevron-right
                        </v-icon>
                    </template>

                </v-data-table>
                </template>
               </v-card>
            </v-tab-item>

        <!-- claims tab -->
        <v-tab-item>
            <v-card>
                <template>
                <v-data-table
                :headers="claimHeaders"
                :items="ViewClaims"
                :class="elevation-1"
                class="px-5"
                :items-per-page="5"
                :search="search"
                no-data-text="This Member Has No Claims"
                >
                <template v-slot:item.action="{ item }">
                    <v-icon
                        style="color:#B45C5C; cursor: pointer;"
                        @click="getClaims(item.id)"
                        >
                        mdi-chevron-right
                    </v-icon>
                </template>
                </v-data-table>
            </template>
            </v-card>
        </v-tab-item>
    </v-tabs>
    </div>
    </v-container>

</div>
   
</template>
<script>
    // import TheNavigationPanel from '../components/TheNavigationPanel';

    export default {
        name: 'communityMembers',
        components: {
            // TheNavigationPanel,
        },

        data: () => ({
            dialog:false,
            id:'',
            name: '',
            clientId: '',
            community:'',
            activePolicyNumber: '',
            contact: '',
            accountName: '',
            checkAdmin: [],
            accountNumber: 0,
            role: '',
            bankName: '',
            policyStatus:'',
            snackbar: false,
            snackbar2: false,
            loading: false,
            headers: [
                {
                text: 'Policy Number',
                align: 'left',
                sortable: false,
                value: 'policy_number',
                class:'font-weight-black'
                },
                { text: 'Premium', value:'premium'},
                { text:'Duration', value:'coverage_period', sortable: false},
                {  text: 'Status', value: 'status', sortable: false },
                {  text: 'Date', value: 'date_created', sortable: false },

                // {  text: 'Id', value: 'id', sortable: false },
                {  text: '', value: 'action', sortable: false },
            ],
            claims:[
                {dateReq:"15/09/2019", amount:'500000', policyNumber:'9090', datePaid:'22/09/2019',  claimStatus:"Paid"},
                {dateReq:"10/01/2020", amount:'700000', policyNumber:'90923', datePaid:'-',  claimStatus:"Outstanding"},
                {dateReq:"13/01/2020", amount:'9800000', policyNumber:'10009850', datePaid:'20/01/2020',  claimStatus:"Paid"},
    
            ],
            claimHeaders: [
                // {
                // text: 'Policy Holder',
                // align: 'left',
                // sortable: true,
                // value: 'policy_holder',
                // class:'font-weight-black'
                // },
                {text: 'Policy Number', value:'policy_number', sortable:false},
                {text: 'Claim Amount', value:'policy_holder_claim_amount', sortable:false},
                {text:'Status', value:'status', sortable: false},
                {text:'Date', value:'date_created', sortable: false},
                { text: '', value: 'action', sortable: false },
            ],
            claimStatus:['Active Policy', 'Inactive Policy', 'All']
        }),
        computed:{
            ViewMember(){
                let trans= this.$store.state.community.membersbyid[0].policyDetails
                for(let j=0; j<trans.length; j++){
                trans[j].premium = trans[j].premium.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                trans[j].date_created= trans[j].date_created.slice(0, 19).replace('T', ' ');
                }
                return trans
            },
            ViewClaims(){
                 let trans =  this.$store.state.community.membersbyid[0].claims
                for(let j=0; j<trans.length; j++){
                trans[j].policy_holder_claim_amount = trans[j].policy_holder_claim_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                trans[j].date_created= trans[j].date_created.slice(0, 19).replace('T', ' ');
                }
                return trans
            },
            member(){
                let mem = this.$store.state.community.membersbyid[0]
                let role='';
                for (let k=0; k<mem.priviledges.length; k++){
                    
                    // if (mem.priviledges.length>0){
                        
                    //     role=mem.priviledges[k]+  role
                    //     console.log(role)
                    //     if(k<mem.priviledges.length-1 ){
                    //         role = role + ', '
                    //         console.log(role)
                    //     }
                        
                    // }else{
                        
                        role = mem.priviledges[k] + "  " + role
                    // }
                    
                }
                if(role===""){
                    role="Member"
                }
                mem.priviledges = role
                return mem
            }
        },
        methods:{ 
            onChange(event) {
            if (event==="Inactive Policy"){
                this.$store.dispatch("getPolicyFilters", {
                "username":this.$store.state.community.membersbyid[0].username,
                "isActive":0
                })
                .then((success)=>{
                console.log('success')
                })
                .catch((error)=>{
                console.log(error);
                });     
            }else if(event==="Active Policy"){
                this.$store.dispatch("getPolicyFilters", {
                "username":this.$store.state.community.membersbyid[0].username,
                "isActive":1
            })
            .then((success)=>{
                console.log('success')
            })
            .catch((error)=>{
            console.log(error);
            });

            }else{
                this.$store.dispatch("getPolicyOneFilter", {
                "username":this.$store.state.community.membersbyid[0].username})
            }
          },
            getPolicy(id){
            this.$store.dispatch("ViewPolicy", id)
                .then((success)=>{
                    console.log(success)
                    this.$router.push(`/community/members/viewPolicy/${success.subscription[0].username}`)
                })
                .catch((error)=>{
                    console.log(error);
                })     
            },
            getClaims(id){
                this.$store.dispatch("ViewClaim", id)
                .then((success)=>{
                    console.log(success)
                    this.$router.push(`/claims/${success.claim[0].policy_holder}`)
                })
                .catch((error)=>{
                    console.log(error);
                })

            },
            save(){
                this.dialog=false
            },
            update(){
                console.log(this.checkAdmin)
                this.loading = true
                this.$store.dispatch("updateMemberRole",{
                    "priviledges": this.checkAdmin,
                    "username": this.clientId,
                    "consultantUsername":this.$store.state.community.logindetails.consultant_id
                })
                .then((success)=>{
                    console.log(success)
                    let id= this.id
                    this.$store.dispatch("MembersById",id)
                    this.loading = false
                    this.snackbar = true
                    this.dialog=false
                })
                .catch((error)=>{
                    console.log(error);
                    this.loading = false
                    this.snackbar2 = true
                    this.dialog=false
                })
            
            }
        },
        created(){
            
            this.name = this.$store.state.community.membersbyid[0].firstname + " " + this.$store.state.community.membersbyid[0].lastname
            this.clientId=this.$store.state.community.membersbyid[0].username
            this.community=this.$store.state.community.membersbyid[0].community_name
            this.contact=this.$store.state.community.membersbyid[0].phonenumber
            this.activePolicyNumber = this.$store.state.community.membersbyid[0].policyDetails.length
            this.bankName = this.$store.state.community.membersbyid[0].bankname
            this.accountName = this.$store.state.community.membersbyid[0].account_name
            this.accountNumber = this.$store.state.community.membersbyid[0].account_number
            this.checkAdmin = this.$store.state.community.membersbyid[0].priviledges
            this.id = this.$store.state.community.membersbyid[0].Id
            this.communityName = this.$store.state.community.membersbyid[0].communityName
        }
    }
</script>